import { Boundaries } from "@planzone/core";
import { moveOrganizationalUnitError } from "@planzone/dto";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: { isPending: false, isSuccessful: false, isFailure: false },
  error: moveOrganizationalUnitError,
};

function handleRequest(state: State): State {
  return {
    ...state,
    error: moveOrganizationalUnitError,
    request: { ...initialState.request, isPending: true },
  };
}

function handleSuccess(state: State): State {
  return {
    ...state,
    error: moveOrganizationalUnitError,
    request: { ...initialState.request, isSuccessful: true },
  };
}

function handleFailure(
  state: State,
  { error }: Boundaries["moveOrganizationalUnit"]["failure"],
): State {
  return {
    ...state,
    error,
    request: { ...initialState.request, isFailure: true },
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.moveOrganizationalUnitRequested]: handleRequest,
    [events.moveOrganizationalUnitSucceeded]: handleSuccess,
    [events.moveOrganizationalUnitFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
